import React, { useState, useEffect } from 'react'
import { Tile, Button, TextArea } from 'carbon-components-react';
import { Close16, ThumbsUp32, ThumbsDown32, ArrowRight32 } from '@carbon/icons-react';
import * as IncidentDetailsConstants from '../IncidentDetailsPage/IncidentDetailsConstants'
import ReactCardFlip from 'react-card-flip';

const RCATabUser = (props) => {

    const [isCategoryFlipped, setIsCategoryFlipped] = useState(false);
    const [isCategoryApproveFlipped, setIsCategoryApproveFlipped] = useState(false);
    const [CategoryFeedbackCount, setCategoryFeedbackCount] = useState(0);
    const [CategoryFeedback, setCategoryFeedback] = useState("");
    const [CategoryFeedbackClicked, setCategoryFeedbackClicked] = useState(false);
    const [isProbableRootCauseFlipped, setIsProbableRootCauseFlipped] = useState(false);
    const [isProbableRootCauseApproveFlipped, setIsProbableRootCauseApproveFlipped] = useState(false);
    const [ProbableRootCauseFeedbackCount, setProbableRootCauseFeedbackCount] = useState(0);
    const [ProbableRootCauseFeedback, setProbableRootCauseFeedback] = useState("");
    const [ProbableRootCauseFeedbackClicked, setProbableRootCauseFeedbackClicked] = useState(false);
    const [isAssignmentFlipped, setIsAssignmentFlipped] = useState(false);
    const [isAssignmentApproveFlipped, setIsAssignmentApproveFlipped] = useState(false);
    const [AssignmentFeedbackCount, setAssignmentFeedbackCount] = useState(0);
    const [AssignmentFeedback, setAssignmentFeedback] = useState();
    const [AssignmentFeedbackClicked, setAssignmentFeedbackClicked] = useState(false);

    //Category
    const handleCategoryApprove = (e) => {
        setIsCategoryApproveFlipped(true);
        setIsCategoryFlipped(!isCategoryFlipped);
        setCategoryFeedbackClicked(false);
        props.updateSomData({ 'type': 'category' }, { 'predicted_category': 'A', 'category': props.predicted_category });
    }
    const handleCategoryReject = () => {
        setIsCategoryApproveFlipped(false);
        setIsCategoryFlipped(!isCategoryFlipped)
        setCategoryFeedbackClicked(false);
    }

    const handleCategoryFlip = () => {
        setIsCategoryFlipped(!isCategoryFlipped);
    };
    const handleCategoryFeedback = () => {
        setCategoryFeedbackClicked(!CategoryFeedbackClicked);
        props.updateSomData({ 'predicted_category': 'R', 'predicted_category_feedback': CategoryFeedback });
    };

    //Assignment
    const handleAssignmentApprove = (e) => {
        setIsAssignmentApproveFlipped(true);
        setIsAssignmentFlipped(!isAssignmentFlipped);
        setAssignmentFeedbackClicked(false);
        props.updateSomData({ 'type': 'assignment_group' }, { 'predicted_owner': 'A', 'assignment_group': props.predicted_owner });
    }
    const handleAssignmentReject = () => {
        setIsAssignmentApproveFlipped(false);
        setIsAssignmentFlipped(!isAssignmentFlipped);
        setAssignmentFeedbackClicked(false);
    }

    const handleAssignmentFlip = () => {
        setIsAssignmentFlipped(!isAssignmentFlipped);
    };
    const handleAssignmentFeedback = () => {
        setAssignmentFeedbackClicked(!AssignmentFeedbackClicked);
        props.updateSomData({ 'predicted_owner': 'R', 'predicted_owner_feedback': AssignmentFeedback });
    };

    //ProbableRootCause
    const handleProbableRootCauseApprove = (e) => {
        setIsProbableRootCauseApproveFlipped(true);
        setIsProbableRootCauseFlipped(!isProbableRootCauseFlipped);
        setProbableRootCauseFeedbackClicked(false);
        props.updateSomData({ 'predicted_rc': 'A' });
    }
    const handleProbableRootCauseReject = () => {
        setIsProbableRootCauseApproveFlipped(false);
        setIsProbableRootCauseFlipped(!isProbableRootCauseFlipped);
        setProbableRootCauseFeedbackClicked(false);
    }

    const handleProbableRootCauseFlip = () => {
        setIsProbableRootCauseFlipped(!isProbableRootCauseFlipped);
    };
    const handleProbableRootCauseFeedback = () => {
        setProbableRootCauseFeedbackClicked(!ProbableRootCauseFeedbackClicked);
        props.updateSomData({ 'predicted_rc': 'R', 'predicted_rc_feedback': ProbableRootCauseFeedback });
    };

    return (
        <div>
            <div className="rca-content upper" >
                <Tile>
                    <div>
                        <label className="carbon-display-Regular-14">{IncidentDetailsConstants.TicketType}</label>
                        <div className="carbon-display-Regular-18">{props.tickettype}</div>
                        <div className={"carbon-display-Regular-14 " + (props.tickettypeConfidence > 50 ? 'text-green' : 'text-danger')}>
                            <span>{props.tickettypeConfidence}</span>
                            <span>%</span>
                            <span className="name">{IncidentDetailsConstants.Confidence}</span>
                        </div>
                    </div>
                </Tile>
                <Tile>
                    <div >
                        <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Priority}</label>
                        <div className="carbon-display-Regular-18">{props.priority}</div>
                        <div className={"carbon-display-Regular-14 " + (props.priorityConfidence > 50 ? 'text-green' : 'text-danger')}>
                            <span>{props.priorityConfidence}</span>
                            <span>%</span>
                            <span className="name">{IncidentDetailsConstants.Confidence}</span>
                        </div>
                    </div>
                </Tile>
                <br></br>
            </div>
            <div className="rca-content" >
                {/* ProbableRootCause */}
                <ReactCardFlip isFlipped={isProbableRootCauseFlipped} flipDirection="horizontal">
                    <Tile className="first-tile">
                        {props.incidentArray.predicted_rc !== "R" ?
                            <div>
                                <div>{props.incidentArray.predicted_rc === "A" ?
                                    <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.ProbableRootCause}</label>
                                    : <label className="carbon-display-Regular-14">{IncidentDetailsConstants.ProbableRootCause}</label>}</div>

                                <div className="carbon-display-Regular-18">{props.predicted_rc}</div>
                                <div className={"carbon-display-Regular-14 " + (props.rcConfidence > 50 ? 'text-green' : 'text-danger')}>
                                    <span>{props.rcConfidence}</span>
                                    <span>%</span>
                                    <span className="name">{IncidentDetailsConstants.Confidence}</span>
                                </div> </div> : ''}

                        {!props.disableIncidentUpdate ?
                            <div className="rca-button-container" >
                                {props.incidentArray.predicted_rc !== "R" && props.incidentArray.predicted_rc !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        kind='secondary'
                                        onClick={handleProbableRootCauseApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button>
                                    : ''}
                                {props.incidentArray.predicted_rc === "R" ?

                                    <div>   <label className="carbon-display-Regular-14">{IncidentDetailsConstants.ProbableRootCause}</label>
                                        <br />
                                        <div className="feedback-tile">
                                            <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback}:</label>
                                            <br /><div>{props.incidentArray.predicted_rc_feedback}</div>
                                        </div> </div> : <Button
                                            renderIcon={ThumbsDown32}
                                            kind='tertiary'
                                            onClick={handleProbableRootCauseReject}
                                        >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>}
                            </div> : ''
                        }
                    </Tile>

                    {isProbableRootCauseApproveFlipped === true ?
                        //  isProbableRootCauseApproveCancelClicked === true &&
                        <Tile className="second-tile">
                            <div>
                                <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                            </div>
                            <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                <Button
                                    renderIcon={Close16}
                                    kind='tertiary'
                                    onClick={handleProbableRootCauseFlip}
                                >{IncidentDetailsConstants.Back}
                                </Button>
                            </div>

                        </Tile>
                        :

                        ProbableRootCauseFeedbackClicked === false ?
                            <Tile className="second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{ProbableRootCauseFeedbackCount}/50</div>
                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="50" rows={2}
                                            onChange={(e) => { setProbableRootCauseFeedbackCount(e.target.value.length); setProbableRootCauseFeedback(e.target.value) }} />
                                        <div className="rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                kind='tertiary'
                                                onClick={handleProbableRootCauseFeedback}
                                                disabled={!ProbableRootCauseFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                kind='tertiary'
                                                onClick={handleProbableRootCauseFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile> :

                            <Tile className="second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                    <Button
                                        renderIcon={Close16}
                                        kind='tertiary'
                                        onClick={handleProbableRootCauseFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div>
                            </Tile>
                    }
                </ReactCardFlip>

                {/* Assignment Group */}
                <ReactCardFlip isFlipped={isAssignmentFlipped} flipDirection="horizontal">
                    <Tile className="first-tile">
                        {props.incidentArray.predicted_owner !== "R" ?
                            <div>
                                <div>{props.incidentArray.predicted_owner === "A" ? <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.AssignmentGroup}</label> :
                                    <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AssignmentGroup}</label>}
                                </div>

                                <div className="carbon-display-Regular-18">{props.predicted_owner}</div>
                                <div className={"carbon-display-Regular-14 " + (props.ownerConfidence > 50 ? 'text-green' : 'text-danger')}>
                                    <span>{props.ownerConfidence}</span>
                                    <span>%</span>
                                    <span className="name">{IncidentDetailsConstants.Confidence}</span>
                                </div></div> : ''
                        }
                        {!props.disableIncidentUpdate ?
                            <div className="rca-button-container">
                                {props.incidentArray.predicted_owner !== "R" && props.incidentArray.predicted_owner !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        kind='secondary'
                                        onClick={handleAssignmentApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button>
                                    : ''}
                                {props.incidentArray.predicted_owner === "R" ?
                                    <div><label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AssignmentGroup}</label>
                                        <div className="feedback-tile"> <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback}:</label>
                                            <br /><div>{props.incidentArray.predicted_owner_feedback}</div>
                                        </div> </div>
                                    :
                                    <Button
                                        renderIcon={ThumbsDown32}
                                        kind='tertiary'
                                        onClick={handleAssignmentReject}
                                    >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>}
                            </div> : ''
                        }
                    </Tile>

                    {isAssignmentApproveFlipped === true ?
                        <Tile className="second-tile">
                            <div className={"accept-tile"}>
                                <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                            </div>
                            {!props.disableIncidentUpdate ?
                                <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                    <Button
                                        renderIcon={Close16}
                                        kind='tertiary'
                                        onClick={handleAssignmentFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div> : ''
                            }

                        </Tile>
                        :

                        AssignmentFeedbackClicked === false ?
                            <Tile className="second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{AssignmentFeedbackCount}/50</div>
                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="50" rows={2}
                                            onChange={(e) => { setAssignmentFeedbackCount(e.target.value.length); setAssignmentFeedback(e.target.value) }} />
                                        <div className="rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                kind='tertiary'
                                                onClick={handleAssignmentFeedback}
                                                disabled={!AssignmentFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                kind='tertiary'
                                                onClick={handleAssignmentFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile> :
                            <Tile className="second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                {!props.disableIncidentUpdate ?
                                    <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                        <Button
                                            renderIcon={Close16}
                                            kind='tertiary'
                                            onClick={handleAssignmentFlip}
                                        >{IncidentDetailsConstants.Back}
                                        </Button>
                                    </div> : ''
                                }
                            </Tile>
                    }
                </ReactCardFlip>

                {/* Category */}
                <ReactCardFlip isFlipped={isCategoryFlipped} flipDirection="horizontal">
                    <Tile className="first-tile">
                        {props.incidentArray.predicted_category !== "R" ?
                            <div>
                                <div>{props.incidentArray.predicted_category === "A" ? <label className="carbon-display-Regular-14" >{IncidentDetailsConstants.AcceptedSuggestionFor} {IncidentDetailsConstants.Category}</label> :
                                    <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Category}</label>
                                }
                                </div>
                                <div className="carbon-display-Regular-18">{props.predicted_category}</div>
                                <div className={"carbon-display-Regular-14 " + (props.categoryConfidence > 50 ? 'text-green' : 'text-danger')}>
                                    <span>{props.categoryConfidence}</span>
                                    <span>%</span>
                                    <span className="name">{IncidentDetailsConstants.Confidence}</span>
                                </div> </div> : ''}
                        {!props.disableIncidentUpdate ?
                            <div className="rca-button-container">
                                {props.incidentArray.predicted_category !== "R" && props.incidentArray.predicted_category !== "A" ?
                                    <Button
                                        renderIcon={ThumbsUp32}
                                        kind='secondary'
                                        onClick={handleCategoryApprove}
                                    >{IncidentDetailsConstants.AcceptSuggestion}
                                    </Button>
                                    : ''}
                                {props.incidentArray.predicted_category === "R" ?
                                    <div>   <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Category}</label>
                                        <div className="feedback-tile"> <label className="carbon-display-Regular-14">{IncidentDetailsConstants.Feedback}:</label>
                                            <br /><div>{props.incidentArray.predicted_category_feedback}</div>
                                        </div></div>
                                    :
                                    <Button
                                        renderIcon={ThumbsDown32}
                                        kind='tertiary'
                                        onClick={handleCategoryReject}
                                    >{IncidentDetailsConstants.RejectSuggestion}
                                    </Button>}
                            </div> : ''
                        }
                    </Tile>

                    {isCategoryApproveFlipped === true ?
                        <Tile className="second-tile">
                            <div>
                                <div>{IncidentDetailsConstants.ToSubmitSuggestion},</div>
                                <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                            </div>
                            {!props.disableIncidentUpdate ?
                                <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                    <Button
                                        renderIcon={Close16}
                                        kind='tertiary'
                                        onClick={handleCategoryFlip}
                                    >{IncidentDetailsConstants.Back}
                                    </Button>
                                </div> : ''
                            }
                        </Tile>
                        :

                        CategoryFeedbackClicked === false ?
                            <Tile className="second-tile">
                                {!props.disableIncidentUpdate ?
                                    <div>
                                        <div className="feedback">{IncidentDetailsConstants.Feedback}</div>
                                        <div className="character-count">{CategoryFeedbackCount}/50</div>
                                        <TextArea id="feedback" placeholder={IncidentDetailsConstants.TypeRejectionFeedback} maxLength="50" rows={2}
                                            onChange={(e) => { setCategoryFeedbackCount(e.target.value.length); setCategoryFeedback(e.target.value) }} />                                <div className="rca-button-container">
                                            <Button
                                                renderIcon={ArrowRight32}
                                                kind='tertiary'
                                                onClick={handleCategoryFeedback}
                                                disabled={!CategoryFeedback}
                                            >{IncidentDetailsConstants.Done}
                                            </Button>
                                            <Button
                                                renderIcon={Close16}
                                                kind='tertiary'
                                                onClick={handleCategoryFlip}
                                            >{IncidentDetailsConstants.Cancel}
                                            </Button>
                                        </div>
                                    </div> : ''
                                }
                            </Tile> :
                            <Tile className="second-tile">
                                <div>
                                    <div>{IncidentDetailsConstants.ToSubmitFeedback},</div>
                                    <div>1.{IncidentDetailsConstants.PressUpdateInTopBar}.</div>
                                    <div>2.{IncidentDetailsConstants.RefreshToViewSuggestion}.</div>
                                </div>
                                {!props.disableIncidentUpdate ?
                                    <div className="rca-button-container" style={{ marginTop: "10px" }}>
                                        <Button
                                            renderIcon={Close16}
                                            kind='tertiary'
                                            onClick={handleCategoryFlip}
                                        >{IncidentDetailsConstants.Back}
                                        </Button>
                                    </div> : ''
                                }
                            </Tile>
                    }
                </ReactCardFlip>
            </div>
            {/* Buttons for Testing */}
            {/* <button onClick={() => { props.updateSomData({ 'predicted_category': '', 'predicted_category_feedback': '' }); }}>Reset Category</button>
            <button onClick={() => { props.updateSomData({ 'predicted_owner': '', 'predicted_owner_feedback': '' }); }}>Reset Assignment</button>
            <button onClick={() => { props.updateSomData({ 'predicted_rc': '', 'predicted_rc_feedback': '' }); }}>Reset PRC</button> */}
        </div >
    );
}
export default RCATabUser;